import * as _ from 'lodash';
import { Injectable } from '@angular/core';

import { ApiModel } from './api.model';

@Injectable()
export class UserModel {
    constructor(private apiModel: ApiModel) {}

    public changePassword(email: string, oldPw: string, newPw: string) {
        const encodedMail = this.encodeEmail(email);

        return this.apiModel.makeHttpRequest({
            method: 'POST',
            url: `${this.apiModel.getUsersEndpoint()}/${encodedMail}/newPassword`,
            body: {
                oldPassword: oldPw,
                password: newPw
            }
        });
    }

    public toggleFollowBrand(data: any) {
        return this.apiModel.makeHttpRequest({
            method: 'POST',
            url: `${this.apiModel.getUsersEndpoint()}/toggleFollow`,
            body: {
                brandName: data.brandName,
                brandId: data.brandId,
                followed: data.followed
            }
        });
    }

    public setPreferredLanguage(language: string) {
        return this.apiModel.makeHttpRequest({
            method: 'POST',
            url: `${this.apiModel.getUsersEndpoint()}/setPreferredLanguage`,
            body: {
                language
            }
        });
    }

    private encodeEmail(emailStr: string) {
        if (_.includes(emailStr, '@')) {
            return encodeURIComponent(emailStr);
        } else {
            return emailStr;
        }
    }
}
